module.exports = __webpack_public_path__ + "img/Jakarta - an adventure in urban planning.ae7014cc.jpg";